var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconService(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "teenyicons:tick-circle-outline",
    clipPath: "url(#clip0_0_334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.7333 22L20.5333 29.3333L32.2667 14.6667M22 42.5333C19.3035 42.5333 16.6335 42.0022 14.1422 40.9703C11.651 39.9384 9.38744 38.426 7.48075 36.5193C5.57405 34.6126 4.06158 32.349 3.02968 29.8578C1.99779 27.3666 1.46667 24.6965 1.46667 22C1.46667 19.3035 1.99779 16.6335 3.02968 14.1422C4.06158 11.651 5.57405 9.38744 7.48075 7.48075C9.38744 5.57405 11.651 4.06158 14.1422 3.02968C16.6335 1.99779 19.3035 1.46667 22 1.46667C27.4458 1.46667 32.6685 3.63 36.5193 7.48075C40.37 11.3315 42.5333 16.5542 42.5333 22C42.5333 27.4458 40.37 32.6685 36.5193 36.5193C32.6685 40.37 27.4458 42.5333 22 42.5333Z",
    stroke: "#1F2B6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconService);
export default __webpack_public_path__ + "static/media/iconService.507c082888052e4d752eb8aff4416a74.svg";
export { ForwardRef as ReactComponent };